import requests from './httpService';

const SoundMasterService = {
  getAllSoundMaster(body) {
    return requests.post(`/soundmaster/list`, body);
  },
  
  findSoundMasterList(body) {
    return requests.post(`/soundmaster/find`, body);
  },
  
  createSoundMaster(body) {
    return requests.post('/soundmaster/add', body);
  },
  
  getSoundMasterById(id) {
    return requests.get(`/soundmaster/${id}`);
  },
  
  updateSoundMaster(id, body) {
    return requests.put(`/soundmaster/${id}`, body);
  },
  
  deleteSoundMaster(id) {
    return requests.delete(`/soundmaster/${id}`);
  },
};

export default SoundMasterService;

